export enum CoOperationHelpInfoType {
	WriterPlayer,
	PlanningActions,
}

export class HelpInfo {
	public static getCoOperationHelpInfo = (
		helpInfoType: CoOperationHelpInfoType,
		turnsPerRound: number
	): { titleText: string; infoText: string } => {
		switch (helpInfoType) {
			case CoOperationHelpInfoType.WriterPlayer:
				return {
					titleText: 'Writers',
					infoText:
						'Writers can write the character dialogue. ' +
						'Your text will be displayed on the shared game screen while other players plan their actions. ' +
						'Create the game narrative or just make up fun quips!<br /><br />' +
						'This is a good option if you want to contribute creatively rather than make the tactical decisions.',
				};
			case CoOperationHelpInfoType.PlanningActions:
				if (turnsPerRound <= 1) {
					return {
						titleText: 'Planning Actions',
						infoText:
							`Select your action, then press "Ready!".<br />` +
							'When you <b>select an action</b>, also <b>choose a direction</b> for it.<br /><br />' +
							'After all the doctor characters have pressed "Ready!", they will perform their actions.<br /><br />' +
							'<b><span style="color: #bdffdc">Move:</span></b> Run to the next tile.<br />' +
							'<b><span style="color: #ffd9b3">Interact:</span></b> Pick up/place down/use objects.<br />' +
							'<b><span style="color: #b9e3ff">Wait:</span></b> Do nothing.<br />' +
							'<b><span style="color: #fffdc0">Throw:</span></b> If an object can be picked up, it can be thrown.',
					};
				} else {
					return {
						titleText: 'Planning Actions',
						infoText:
							`Schedule ${turnsPerRound} actions, then press "Ready!".<br />` +
							'Each time you <b>select an action</b>, also <b>choose a direction</b> for it.<br /><br />' +
							'After all the doctor characters have pressed "Ready!", they will perform their scheduled actions.<br /><br />' +
							'<b><span style="color: #bdffdc">Move:</span></b> Run to the next tile.<br />' +
							'<b><span style="color: #ffd9b3">Interact:</span></b> Pick up/place down/use objects.<br />' +
							'<b><span style="color: #b9e3ff">Wait:</span></b> Do nothing.<br />' +
							'<b><span style="color: #fffdc0">Throw:</span></b> If an object can be picked up, it can be thrown.',
					};
				}
			default:
				throw new Error(`Unexpected ${CoOperationHelpInfoType}: ${helpInfoType}`);
		}
	};
}
